import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { isDesktop } from "../../../utils";
import ComponentDecider from "../ComponentDecider";
import { GridRow, GridColumn, Img } from "arv-reactcomponents";
import staticEndpoints from "../../../api/endPoints/staticEndpoints";
import { BRAND_SPECIFIC_CONFIGS } from "../../../constants";

@inject("BrandStore", "CommonStore")
@observer
class MasterComponent extends Component {
  static showStroke(data, id) {
    const { type, key, sectionTitle } = data;
    const finalType = type || key;
    return (
      sectionTitle &&
      finalType &&
      finalType.toLowerCase() === "secondarystorysection" &&
      BRAND_SPECIFIC_CONFIGS &&
      BRAND_SPECIFIC_CONFIGS[id] &&
      BRAND_SPECIFIC_CONFIGS[id].includes("showMasterTemplateBrushStroke")
    );
  }
  static getSubComponentLayout(data, mainData, BrandStore) {
    const width = data.width || 12;
    const val =
      (mainData && mainData.type && mainData.type.toLowerCase()) || "";
    const customClass = `nw-${BrandStore && BrandStore.brandId}-${val}`;
    const baseClass = `nw-${val}`;
    return `nwc-grid-col-sm-${width}  ${customClass} ${baseClass}`;
  }
  static sortSubComponents(data) {
    return isDesktop
      ? data && data.children && data.children.sort((a, b) => a.dPos - b.dPos)
      : data && data.children;
  }

  constructor(props) {
    super(props);
    this.state = {
      hiddenComponents: [],
    };
    this.componentType = this.componentType.bind(this);
    this.shouldComponentBeShown = this.shouldComponentBeShown.bind(this);
    this.hideComponent = this.hideComponent.bind(this);
    this.getMasterComponentLayout = this.getMasterComponentLayout.bind(this);
  }
  getMasterComponentLayout(data, BrandStore, sectionIndex) {
    const { hiddenComponents } = this.state;
    const val = (data && data.type && data.type.toLowerCase()) || "";
    const customClass = `nw-${BrandStore && BrandStore.brandId}-${val}`;
    const hasChildren = (data && data.children && data.children.length) || 0;
    const allChildrenAreNotValid = hiddenComponents.length === hasChildren;
    const templateClass = `nw-${BrandStore &&
      BrandStore.templateType &&
      BrandStore.templateType.toLowerCase()}`;
    const { isBrandPage } = this.props.CommonStore || {};
    const sectionClass = !isBrandPage ? `nw-section${sectionIndex}` : "";
    return ` ${customClass} ${
      !allChildrenAreNotValid ? "" : "nwc-hide"
    } ${templateClass} ${sectionClass}`;
  }
  componentType(data, parentData, index) {
    const { type, key } = data;
    const { sectionIndex } = this.props;
    const newSectionIndex = sectionIndex >= 0 ? sectionIndex : index;
    if (type === "section" || key === "section") {
      return (
        <MasterComponent
          data={data}
          sectionIndex={newSectionIndex}
          componentIndex={index}
        />
      );
    }
    return (
      <ComponentDecider
        componentData={data}
        parentData={parentData}
        hideComponent={() => this.hideComponent(index)}
        sectionIndex={newSectionIndex}
        componentIndex={index}
      />
    );
  }
  shouldComponentBeShown(index) {
    return this.state.hiddenComponents.includes(index) ? "nwc-hide" : "";
  }
  hideComponent(index) {
    const { hiddenComponents } = this.state;
    hiddenComponents.push(index);
    this.setState({ hiddenComponents });
  }
  render() {
    const { data, BrandStore, sectionIndex } = this.props;
    const sortedSubComponents = MasterComponent.sortSubComponents(data);
    const { carousalEnabled, sectionTitle, sectionSubtitle } = data;
    const sectionClassName = this.getMasterComponentLayout(
      data,
      BrandStore,
      sectionIndex,
    );
    return (
      <GridRow
        className={` nw-mastertemplate-sectioncomponent ${sectionClassName}`}
      >
        {sectionTitle && (
          <GridColumn
            className={`nw-mastertemplate-sectioncomponent-titlecontainer  ${sectionClassName}`}
          >
            <h1
              className={`nw-mastertemplate-sectioncomponent-title  ${sectionClassName}`}
            >
              {sectionTitle}
            </h1>
            {MasterComponent.showStroke(data, BrandStore.brandId) && (
              <Img
                className="nw-mastertemplate-brushstroke"
                src={staticEndpoints.brush_stroke}
              />
            )}
          </GridColumn>
        )}
        {sectionSubtitle && (
          <GridColumn className="nw-mastertemplate-sectioncomponent-subtitlecontainer">
            <p className="nw-mastertemplate-sectioncomponent-subtitle">
              {sectionSubtitle}
            </p>
          </GridColumn>
        )}
        {!carousalEnabled &&
          sortedSubComponents &&
          sortedSubComponents.map((componentData, index) => (
            <GridColumn
              className={`nw-mastertemplate-subcomponent ${MasterComponent.getSubComponentLayout(
                componentData,
                data,
                BrandStore,
              )} ${this.shouldComponentBeShown(index)}`}
              key={componentData.type}
            >
              {this.componentType(componentData, data, index)}
            </GridColumn>
          ))}
        {carousalEnabled && (
          <ComponentDecider componentData={data} sectionIndex={sectionIndex} />
        )}
      </GridRow>
    );
  }
}
MasterComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isBrandPage: PropTypes.bool.isRequired,
  }).isRequired,
  sectionIndex: PropTypes.number.isRequired,
  data: PropTypes.shape({}).isRequired,
  BrandStore: PropTypes.shape({}).isRequired,
};
export default MasterComponent;



// WEBPACK FOOTER //
// ./src/component/MasterTemplate/MasterComponent/index.js